const $ = jQuery.noConflict();
import 'select2/dist/js/select2.full.js';
import SingleProduct from './singleProduct';

'use strict';
const Select2 = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$select: $('.js-select'),
	$selectCustomOrder: $('#js-custom-order-select-color'),
	$selectCustomOrderAddresses: $('.custom-order-select'),
	$selectCustomOrderPreservation: $('.custom-order-preservation'),
	$selectGiftCardTime: $('#wps_wgm_time'),

	/** @description Initialize */
	init: function() {
		this.select2();
		$('#billing_country option').each(function() {
			if($(this).is(':selected')) {
				$('#billing_country_field label').addClass('is-moved');
			}
		});
		$('#billing_state option').each(function() {
			if($(this).is(':selected')) {
				$('#billing_state_field label').addClass('is-moved');
			}
		});
		$('#shipping_country option').each(function() {
			if($(this).is(':selected')) {
				$('#shipping_country_field label').addClass('is-moved');
			}
		});
		$('#shipping_state option').each(function() {
			if($(this).is(':selected')) {
				$('#shipping_state_field label').addClass('is-moved');
			}
		});
	},

	select2: () => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */
		Select2.$select.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'custom-class'
		});
		//
		Select2.$selectCustomOrder.select2({
			width: 'style',
			dropdownCssClass: 'custom-order-select-color-dropdown',
			allowClear: true,
			templateResult: SingleProduct.customSelect2RowTemplate
		});
		Select2.$selectCustomOrderAddresses.select2({
			width: 'style',
			dropdownCssClass: 'custom-order-select-addresses-dropdown',
			allowClear: true,
		});
		Select2.$selectCustomOrderPreservation.select2({
			width: 'style',
			dropdownCssClass: 'custom-order-select-color-dropdown custom-order-select-preservation-dropdown',
			allowClear: true,
		});
		Select2.$selectGiftCardTime.select2({
			width: 'style',
			dropdownCssClass: 'gift-card-select-dropdown',
			allowClear: true,
		});
	}
};

export default Select2;
